/**
 * Pdf portal
 * Portal to generate PDF and handle authentication.
 *
 * OpenAPI spec version: 1.0.32
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ChildrenGroup } from './childrenGroup';
import { Group } from './group';

/**
 * Base class serializer for all OpenAPI serializers.  It only implements create/update method without any logic to prevent \"abstract\" warning by pylint.
 */
export interface GroupReportInfo { 
    groups: Array<Group>;
    children: Array<ChildrenGroup>;
    dateFrom: string;
    dateTo: string;
    childrenCount: number;
    averageAge: number;
}